import { calculatePriceMargin } from "./index";

export function formatRTRConnectionResource(productData, normalizedSizesDictionary, retailerMargin) {
  const { margin } = retailerMargin;

  let isAllStandardSizes = true;
  const sizes = productData.sizes.map(s => {
    const size = s[0].Size;
    const normalized = normalizedSizesDictionary[size];
    if (isAllStandardSizes && !normalized) {
      isAllStandardSizes = false;
    }

    return {
      id: s[0].SKU,
      size,
      quantity: s.length,
      normalized: normalized || "-"
    };
  });

  const incomingWholesale = Number(productData.data["Clearance Price"]).toFixed(2);
  const retail = Number(Number(productData.data["Msrp Amount"]).toFixed(2));
  const { isWholesaleCalculatedFromMargin, wholesale } = calculatePriceMargin({
    wholesale: incomingWholesale,
    margin,
    retail
  });

  return {
    condition: "Very Good",
    title: productData.data["Vendor Product Name"],
    color: productData.data["Primary Color"] ? productData.data["Primary Color"] : "",
    incomingBrand: productData.data.Vendor,
    brand: productData?.brand && `${productData.brand}`,
    retailerDescription: `${productData.data.Description} ${productData.data["Product Details"]}`,
    sizes,
    sku: productData.data["Product ID"],
    wholesale,
    images: productData.images.filter(Boolean).map(i => `${i.s3path}`),
    incomingPrices: {
      wholesale: incomingWholesale,
      retail,
      compareAtPrice: Number(Number(productData.data["Msrp Amount"]).toFixed(2))
    },
    hasWholesale: wholesale > 0,
    isAllStandardSizes,
    isWholesaleCalculatedFromMargin
  };
}
